import { render, staticRenderFns } from "./ImportFileCost.vue?vue&type=template&id=fb54b38c&scoped=true"
import script from "./ImportFileCost.vue?vue&type=script&lang=js"
export * from "./ImportFileCost.vue?vue&type=script&lang=js"
import style0 from "./ImportFileCost.vue?vue&type=style&index=0&id=fb54b38c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb54b38c",
  null
  
)

export default component.exports